import { MaterialIcon } from '../../../MaterialIcon';
import { ProductDetailsAttributeGroups } from '../../BaseComponents/ProductDetailsAttributeGroups';
import { ProductDetailsSectionHeader } from '../../BaseComponents/ProductDetailsSectionHeader';
import { hasProductOffers } from '../../utils/sectionVisibility/sectionVisibility';
import { ProductDetailsSectionGift } from '../ProductDetailsSectionGift';
import type { ConfiguredSectionProps } from './types';

/**
 * Offers is a slot whose content is not only attributes: the reward component (gift carousel +
 * offer accordions, the same one CC renders) comes first and is driven by the product's offers,
 * then any configured groups follow. The header is rendered here from the section label
 * (= `tab_label`), so the tab and the title always agree, and the reward component skips its own
 * `pd_nav_offers` header.
 */
export const ProductDetailsSectionConfiguredOffers: React.FC<
  ConfiguredSectionProps
> = (section) => (
  <div className="flex flex-col gap-6" data-component="pdp-configured-offers">
    <ProductDetailsSectionHeader
      icon={<MaterialIcon icon={section.icon} size={3} />}
    >
      {section.label}
    </ProductDetailsSectionHeader>
    {hasProductOffers(section.product) && (
      <ProductDetailsSectionGift
        {...section.product}
        vertical={section.vertical}
        pushDataLayer={section.pushDataLayer}
        sectionTitle={section.label}
        hideHeader
      />
    )}
    <ProductDetailsAttributeGroups
      groups={section.groups}
      sectionTitle={section.label}
      product={section.product}
      pushDataLayer={section.pushDataLayer}
    />
  </div>
);
